$(document).on('turbolinks:load', function() {
  // disable all navigation and input within disabled forms
  const $disabledForm = $('.disabled-annotation')
  const inputs = 'button,input,select,textarea'
  $disabledForm.find(inputs).attr('disabled', 'disabled');
  $disabledForm.find('a').attr('tabIndex', -1)
});
